import Cookies from "universal-cookie"
import { jwtDecode } from "jwt-decode"
import { getObject, postObject, REACT_APP_API_URL } from "../Common/js/api_common"
import { DebugManager } from "../Common/jsx/DebugManager"

export const ENDPOINT_PYLOG = "/pylog"
export const ENDPOINT_AUTH = "/auth"
export const ENDPOINT_REFRESH_TOKEN = "/refresh_token"
export const ENDPOINT_FORGOT_PASSWORD = "/forgot_password"

let dbMgrActivate = false

export async function pylog(pylog) {
  let dbMgr = new DebugManager("ApiAuth")
  dbMgr.activate(dbMgrActivate)
  let debug = dbMgr.debug
  // debug("process", process)
  // debug("env", process.env)
  debug("pylog", REACT_APP_API_URL, ENDPOINT_PYLOG, pylog)
  return await getObject(REACT_APP_API_URL + ENDPOINT_PYLOG + "?q=" + pylog, false)
}

export async function auth(email, password) {
  let dbMgr = new DebugManager("ApiAuth")
  dbMgr.activate(dbMgrActivate)
  let debug = dbMgr.debug
  debug("auth")
  debug("process.env:", process.env)

  let postData = {
    email: email,
    password: password,
  }
  debug("postData:", postData)
  let ret = await postObject(REACT_APP_API_URL + ENDPOINT_AUTH, postData, false)
  ret = await ret.json()

  debug("return auth:", ret)
  return ret
}

export async function getToken() {
  let dbMgr = new DebugManager("ApiAuth")
  dbMgr.activate(dbMgrActivate)
  let debug = dbMgr.debug
  debug("getToken")

  let cookies = new Cookies()
  let token = cookies.get("bg_token")
  debug("token:", token)

  let isTokenExpired = true
  if (token !== "undefined" && token) {
    const marginMillisec = 10000
    const decodedToken = jwtDecode(token)
    const timeOffset = cookies.get("bg_time_offset")
    const currentTime = (Date.now() + parseInt(timeOffset, 10) + marginMillisec) / 1000

    debug("token expires in:", decodedToken.exp - currentTime, "( with margin " + marginMillisec / 1000 + "s )")
    isTokenExpired = decodedToken.exp < currentTime
  }
  debug("isTokenExpired:", isTokenExpired)

  if (isTokenExpired) {
    let refreshToken = { refresh_token: cookies.get("bg_refresh_token") }
    debug("refreshToken:", refreshToken)

    let refreshedToken = await postObject(REACT_APP_API_URL + ENDPOINT_REFRESH_TOKEN, refreshToken, false)

    if (refreshedToken.status !== undefined && refreshedToken.status === 401) {
      debug("FAILED REFRESH")
      cookies.remove("bg_user", { path: "/" })
      cookies.remove("bg_token", { path: "/" })
      cookies.remove("bg_refresh_token", { path: "/" })
      cookies.remove("bg_time_offset", { path: "/" })
      window.location = "/"
    }

    debug("refreshedToken:", refreshedToken)

    refreshedToken = await refreshedToken.json()
    token = refreshedToken.token
    cookies.set("bg_token", token, { path: "/" })
    debug("new token:", token)
  }

  return token
}

export async function forgotPasswordRequest(email) {
  let dbMgr = new DebugManager("ApiAuth")
  dbMgr.activate(dbMgrActivate)
  let debug = dbMgr.debug
  debug("forgotPasswordRequest email:", email)

  let postData = {
    email: email,
  }
  debug("postData:", postData)
  let ret = await postObject(REACT_APP_API_URL + ENDPOINT_FORGOT_PASSWORD + "/", postData, false)

  debug("return forgotPasswordRequest:", ret)
  return ret
}

export async function passwordReset(token, password) {
  let dbMgr = new DebugManager("ApiAuth")
  dbMgr.activate(dbMgrActivate)
  let debug = dbMgr.debug
  debug("passwordReset password:", password, "token:", token)

  let postData = {
    password: password,
  }
  debug("postData:", postData)
  let ret = await postObject(REACT_APP_API_URL + ENDPOINT_FORGOT_PASSWORD + "/" + token, postData, false)

  debug("return passwordReset:", ret)
  return ret
}
